const a2censo = {
  FORMS: [
    {
      type: 'a2censo-contact-form',
      name: 'A2censoContactForm',
      message: {
        open: 'Formulario contacto',
        send: 'Envío Formulario De Contacto'
      }
    }
  ],
  CSS: {
    id: '66ccc1f52ea44dba177271bd',
    name: 'a2censo',
    avatar: {
      name: 'a2censo',
      header: 'https://chatbotqa.gatblac.com/static/avatar/a2censo/a2censo.svg',
      new: 'https://chatbotqa.gatblac.com/static/avatar/nuam/Avatar-1.svg',
      open: 'https://chatbotqa.gatblac.com/static/avatar/nuam/Avatar-1.svg',
      close: 'https://chatbotqa.gatblac.com/static/avatar/nuam/Avatar-1.svg'
    },
    style: {
      score: {
        inactiveColor: '#fff',
        activeColor: '#618DD1',
        borderColor: '#618DD1'
      }
    }
  }
}

export default a2censo
